package one.healthium.tutorial.domain

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed class TutorialModel {

    @Serializable
    @SerialName("intro")
    data class IntroTutorial(
        @SerialName("screens") val screens: List<TutorialScreenConfig>
    ) : TutorialModel()

    @Serializable
    @SerialName("meal_plan")
    data object MealPlanTutorial : TutorialModel()
}
